import { Client } from "../../clients/client";

import { PaginationForm, Pagination } from "@/common/mixins/pagination";
import { Channel } from "./models/Channel";

export class ChannelUseCase {
  constructor(private client: Client) {}

  public async getChannels(form: PaginationForm): Promise<Pagination<Channel>> {
    return this.client.channels.getChannels({
      page: form && form.page,
      limit: form && form.perPage
    });
  }
}
